import {
  SET_USER_PROFILE,
  UPDATE_USER_PROFILE,
  USER_PROFILE_LOADING,
  USER_PROFILE_ERROR,
  UPDATE_PROFILE_FIRST_ADDRESS,
  OPEN_MODAL_UPDATE_PERSONAL_DATA,
  CLOSE_MODAL_UPDATE_PERSONAL_DATA,
} from '../types/ProfileTypes';
import { mustIn, mustOut } from './AuthenticationActions';
import {
  setAddresses,
  setBillingAddresses,
  haveMainAddress,
} from './AddressesActions';
import { successMessage, errorMessage } from './FlashActions';
import {
  callGetUserProfile,
  updateUserProfile,
} from '../../services/ProfileService';
import { formatDateForCommerce } from './../../helpers/DateFormatter';
import getTokens from '../../providers/getTokens';

export const setUserProfile = (profile) => {
  return {
    type: SET_USER_PROFILE,
    profile,
  };
};

export const userProfileLoading = () => {
  return {
    type: USER_PROFILE_LOADING,
  };
};

export const userProfileUpdated = () => {
  return {
    type: UPDATE_USER_PROFILE,
  };
};

export const userProfileError = () => {
  return {
    type: USER_PROFILE_ERROR,
  };
};

export const setUserFirstAddress = (profile) => {
  return {
    type: UPDATE_PROFILE_FIRST_ADDRESS,
    profile,
  };
};

export const openModalUpdatePersonalData = (modalInformation) => {
  return { type: OPEN_MODAL_UPDATE_PERSONAL_DATA, modalInformation };
};

export const closeModalUpdatePersonalData = () => {
  return { type: CLOSE_MODAL_UPDATE_PERSONAL_DATA };
};

export const getUserProfile = (wcToken, wcAuthenticationToken) => {
  return async (dispatch) => {
    try {
      if (!wcToken || !wcAuthenticationToken) {
        dispatch(mustOut());
        return { success: false };
      } else {
        const res = await callGetUserProfile(wcToken);
        return res.status !== 200
          ? resolveError(dispatch)
          : resolveSuccess(dispatch, res.data.content);
      }
    } catch (err) {
      return resolveError(dispatch);
    }
  };
};

const mainAddressExtractor = (content) => {
  return {
    addressId: content.addressId,
    addressLine: content.addressLine,
    addressType: content.addressType,
    city: content.city,
    country: content.country,
    firstName: content.firstName,
    lastName: content.lastName,
    nickName: 'Dirección Inicial',
    phone1: content.phone1,
    mobilePhone1: content.mobilePhone1,
    fax1: content.fax1,
    fax2: content.fax2,
    primary: content.primary,
    state: content.state,
    isMainCommerce: true,
  };
};

const resolveSuccess = (dispatch, content) => {
  dispatch(setUserProfile(content));
  const mainAddress = mainAddressExtractor(content);
  if (content.contact) {
    const wholeContact = mainAddress.addressLine
      ? [mainAddress, ...content.contact]
      : [...content.contact];
    resolveAddresses(dispatch, wholeContact);
  } else {
    if (mainAddress?.addressLine) resolveAddresses(dispatch, [mainAddress]);
  }
  dispatch(mustIn());
  return { success: true };
};

const resolveAddresses = (dispatch, contact) => {
  const normalAddresses = [];
  const billingAddresses = [];
  const addresses = contact || [];
  addresses.forEach((address) => {
    if (address.primary === 'true') dispatch(haveMainAddress(true));
    if (address.addressType === 'Billing') billingAddresses.push(address);
    else normalAddresses.push(address);
  });

  dispatch(setAddresses(normalAddresses));
  dispatch(setBillingAddresses(billingAddresses));
};

const resolveError = (dispatch) => {
  dispatch(mustOut());
  return { success: false };
};

export const updateProfile = (userId, data) => {
  const wcToken = getTokens().wcToken();
  const wcAuthenticationToken = getTokens().wcTrustedToken();

  return async (dispatch) => {
    try {
      data.dateOfBirth = formatDateForCommerce(data.dateOfBirth);
      dispatch(userProfileLoading());
      const res = await updateUserProfile(userId, data);
      if (res.status === 201) {
        dispatch(userProfileUpdated());
        await dispatch(getUserProfile(wcToken, wcAuthenticationToken));
        dispatch(successMessage('El perfil se ha actualizado correctamente'));
      } else if (res.status === 400) {
        dispatch(userProfileError());
        dispatch(
          errorMessage(
            'El correo ingresado ya existe, por favor usa uno diferente',
          ),
        );
      } else {
        dispatch(userProfileError());
        dispatch(errorMessage('Hubo un problema al actualizar el perfil'));
      }
    } catch (err) {
      dispatch(userProfileError());
      dispatch(errorMessage('Hubo un problema al actualizar el perfil'));
    }
  };
};
